import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import classes from "./OquvDasturiDetails.module.css";
import { testUrl } from "../BaseData";

const OquvDasturiDetails = () => {
    const navigate = useNavigate();
    const { short_name } = useParams();
    const { t, i18n } = useTranslation();
    const [direction, setDirection] = useState(null);
    const [kafedra, setKafedra] = useState(null);
    const [directions, setDirections] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setLoading(true);
        setError(null);

        axios.get(testUrl + "/api/directions/" + short_name)
            .then((res) => {
                const data = res.data;
                if (data) {
                    setDirection(data?.direction || null);
                    setDirections(data?.directions || []);
                    setKafedra(data?.kafedra || null);
                } else {
                    setError("Ma'lumotlar topilmadi");
                }
            })
            .catch(() => setError("Ma'lumotlarni yuklashda xatolik"))
            .finally(() => setLoading(false));

    }, [short_name, i18n.language]);

    const getDirectionName = (directionObj) => {
        if (!directionObj) return t("no_name_available");
        const title = directionObj[`name_${i18n.language}`];
        return title || directionObj.name_uz || t("no_name_available");
    };

    if (loading) return <p>Yuklanmoqda...</p>;

    if (!direction) {
        return <p>O'quv dasturi topilmadi</p>;
    }

    const curriculum = direction.curriculum;

    return (
        <div className={classes.mainContainer}>
            <div data-aos="fade-up" className={classes["rahbariyat-container"]}>
                <h1 className={classes["page-title"]}>
                    {getDirectionName(direction)}
                </h1>

                {curriculum?.dastur_file ? (
                    <div className={classes.downloadSection}>
                        <a href={curriculum.dastur_file} target="_blank" rel="noopener noreferrer" className={classes.downloadBtn}>
                            O'quv reja (Yuklab olish)
                        </a>
                    </div>
                ) : (
                    <p style={{ marginTop: "20px" }}>O'quv reja yuklanmagan.</p>
                )}

                {curriculum?.subjects && curriculum.subjects.length > 0 && (
                    <div className={classes.subjectsSection}>
                        <h3 className={classes.subjectsTitle}>
                            Yo'nalish fanlari
                        </h3>
                        <table className={classes.subjectsTable}>
                            <thead>
                                <tr>
                                    <th>T/r</th>
                                    <th>Fanning kodi</th>
                                    <th>Fan nomlari</th>
                                    <th>Kursi</th>
                                    <th>Dastur</th>
                                </tr>
                            </thead>
                            <tbody>
                                {curriculum.subjects.sort((a, b) => {
                                    // Custom sort for numbers with decimals like "1.1", "2"
                                    const numA = parseFloat(a.number.replace(',', '.'));
                                    const numB = parseFloat(b.number.replace(',', '.'));
                                    if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
                                    return a.number.localeCompare(b.number);
                                }).map((subject) => (
                                    <tr key={subject.id}>
                                        <td>{subject.number}</td>
                                        <td>{subject.code}</td>
                                        <td>{subject[`name_${i18n.language}`] || subject.name_uz}</td>
                                        <td>{subject.course}-kurs</td>
                                        <td>
                                            {subject.dastur_file ? (
                                                <a href={subject.dastur_file} target="_blank" rel="noopener noreferrer" style={{ color: '#002e5b', textDecoration: 'underline', fontWeight: '500' }}>
                                                    Yuklab olish
                                                </a>
                                            ) : (
                                                <span style={{ color: '#999' }}>Mavjud emas</span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            <div className={classes["sidebar-wrapper"]}>
                <div className={classes.sidebar}>
                    <h3 className={classes["sidebar-title"]}>
                        {kafedra && kafedra[`name_${i18n.language}`]} yo'nalishlari
                    </h3>
                    <ul style={{ listStyle: 'none', padding: 0 }}>
                        {directions && directions.length > 0 ? (
                            directions.map((direct, index) => (
                                <li
                                    onClick={() => navigate(`/oquv-dasturi/${direct.short_name}`)}
                                    key={direct.id}
                                    style={{ marginBottom: '10px' }}
                                    className={direct.short_name === short_name ? classes.active : ''}
                                >
                                    <span style={{ marginRight: '8px', color: '#133654', fontWeight: 'bold' }}>{index + 1}.</span>
                                    <span style={{ cursor: 'pointer', color: '#133654' }}>
                                        {getDirectionName(direct)}
                                    </span>
                                </li>
                            ))
                        ) : (
                            <li>{t("no direction data")}</li>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default OquvDasturiDetails;
